module.exports = __webpack_public_path__ + "media/icons/icon_email-210c72bf.png";